<template>
  <div class="myInfo">
    <el-main>
      <UserCenterTop />
      <el-row class="nofull event_content">
        <UserMenu :myMenuActiveId="myMenuActiveId" />
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>学者中心</el-breadcrumb-item>
            <el-breadcrumb-item>个人信息</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="row_header">
            <div class="row_title fl">个人信息</div>
            <div class="row_inside fr"></div>
          </div>
          <MyInfoMenu :myInfoMenuActiveIndex="myInfoMenuActiveIndex" />
          <!-- 我的基础信息表单显示编辑 -->
          <div class="myInfoForm">
            <el-form :model="form" ref="form" :rules="formRegistrationRule">
              <el-row :gutter="10">
                <el-col :span="18">
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item
                        :label="scholarType.name"
                        :label-width="formLabelWidth"
                      >
                        <el-select
                          disabled
                          v-model="form.scholar_level"
                          size="small"
                          :placeholder="scholarType.name"
                        >
                          <el-option
                            v-for="item in scholarType.items"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="性别:" :label-width="formLabelWidth">
                        <el-radio-group v-model="form.gender">
                          <el-radio
                            v-for="item in gender_type_list.items"
                            :key="item.value"
                            :label="item.value"
                            >{{ item.name }}
                          </el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!-- <el-row :gutter="10">
                                        <el-col :span="12">
                                            <el-form-item label="姓名:" :label-width="formLabelWidth">
                                                <el-input v-model="form.name" size="small"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">

                                        </el-col>
                                    </el-row> -->
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item
                        label="中文姓:"
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          v-model="form.last_name_zh"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="中文名:"
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          v-model="form.first_name_zh"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item
                        label="First Name:"
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          v-model="form.first_name_en"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="Last Name:"
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          v-model="form.last_name_en"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="职务:" :label-width="formLabelWidth">
                        <el-input v-model="form.duty" size="small"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="职称:" :label-width="formLabelWidth">
                        <el-input
                          v-model="form.job_title"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item
                        label="单位(中文):"
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          v-model="form.institution"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="单位(英文):"
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          v-model="form.institution_en"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item
                        label="手机:"
                        :label-width="formLabelWidth"
                        prop="cellphone"
                      >
                        <el-input
                          disabled
                          v-model="form.cellphone"
                          size="small"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="电话:" :label-width="formLabelWidth">
                        <el-input v-model="form.phone" size="small"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="传真:" :label-width="formLabelWidth">
                        <el-input v-model="form.fax" size="small"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="Email:"
                        :label-width="formLabelWidth"
                      >
                        <span>{{ form.email }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <!-- 头像上传 -->
                  <el-upload
                    class="avatar-uploader"
                    action
                    :http-request="avatarUpLoad"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img
                      v-if="form.avatar"
                      :src="
                        '/forum-pub-api/v1/minio/getFile?file_url=' +
                        form.avatar
                      "
                      :key="form.avatar"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="9">
                  <el-form-item label="证件类型:" :label-width="formLabelWidth">
                    <el-select
                      v-model="form.certificate_type"
                      size="small"
                      placeholder="证件类型"
                    >
                      <el-option
                        v-for="item in certificate_type_list.items"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="证件号码:" :label-width="formLabelWidth">
                    <el-input
                      v-model="form.certificate_number"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-row :gutter="10">
                <el-col :span="9">
                  <el-form-item label="国家:" :label-width="formLabelWidth">
                    <el-input v-model="form.country" size="small"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="城市:" :label-width="formLabelWidth">
                    <el-input v-model="form.city" size="small"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="地址:" :label-width="formLabelWidth">
                    <el-input
                      v-model="form.address"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="邮编:" :label-width="formLabelWidth">
                    <el-input v-model="form.postcode" size="small"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="简介:" :label-width="formLabelWidth">
                    <el-input
                      v-model="form.description"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-button
            type="primary"
            @click="handlePutScholarInfo"
            style="margin-top: 50px; float: left"
            >保存</el-button
          >
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import UserMenu from '@/components/UserMenu.vue';
import UserCenterTop from '@/components/UserCenterTop.vue';
import MyInfoMenu from '@/components/MyInfoMenu.vue';
import { postAvatarUpload } from '@/apis/avatar.js';
// import {getScholarInfo} from "@/apis/scholar.js";
import { getEnum } from '@/apis/enum.js';
// import {getFile} from "@/apis/getFile.js";
import { putScholarInfo } from '@/apis/scholar.js';
export default {
  name: 'MyInfo',
  components: {
    UserMenu,
    UserCenterTop,
    MyInfoMenu,
  },

  mounted() {
    this.$emit('activeIndex', '3');
    this.$emit('pageClass', 'userCenter');
    getEnum()
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.certificate_type_list =
              res.data.data.enum_info.certificate_type;
            this.scholarType = res.data.data.enum_info.scholar_type;
            this.gender_type_list = res.data.data.enum_info.gender_type;
            console.log(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        } else {
          this.$message.error('未请求成功');
          console.log('错误');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  data() {
    return {
      certificate_type_list: {},
      scholarType: {},
      gender_type_list: {},
      myMenuActiveId: '2',
      myInfoMenuActiveIndex: '1',
      // form: {
      // 个人信息数据
      /* firstName: '',
                    lastName: '',
                    enFirstName: '',
                    enLastName: '',
                    sex: '',
                    job: '',
                    org: '',
                    avatar: '',
                    country: '',
                    city: '',
                    location: '',
                    cellPhone: '',
                    email: '',
                    tel: '',
                    lic: '',
                    licOptions: [
                        {
                            value: '身份证',
                            label: '身份证'
                        },
                        {
                            value: '护照',
                            label: '护照'
                        },
                        {
                            value: '记者证',
                            label: '记者证'
                        },
                    ],
                    licNum: '',
                    */
      // },
      formLabelWidth: '100px',
      avatarFileName: '',
      // 报名信息规则
      formRegistrationRule: {
        cellphone: [{ validator: this.checkCellPhone, trigger: 'blur' }],
      },
    };
  },
  methods: {
    checkCellPhone(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    },
    // 头像上传方法
    avatarUpLoad(file) {
      const formData = new FormData();
      formData.append('avatar', file.file);
      postAvatarUpload(formData).then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.$message.success('头像上传成功');
            this.$store.dispatch('toGetCurrentUser');
            console.log(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.form.avatarUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      //this.avatarFileName.push(file.name);
      const isJPG = file.type === 'image/jpeg';
      const isGIF = file.type === 'image/gif';
      const isPNG = file.type === 'image/png';
      const isBMP = file.type === 'image/bmp';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isGIF && !isPNG && !isBMP) {
        this.$message.error('上传头像图片支持JPG/PNG/BMP/GIF格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },

    handlePutScholarInfo() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          putScholarInfo({
            //'name': this.form.name,
            name: this.form.last_name_zh + this.form.first_name_zh,
            gender: this.form.gender,
            duty: this.form.duty,
            job_title: this.form.job_title,
            institution: this.form.institution,
            cellphone: this.form.cellphone,
            phone: this.form.phone,
            fax: this.form.fax,
            // 'email': this.form.email,
            avatar: this.form.avatarUrl,
            certificate_type: this.form.certificate_type,
            certificate_number: this.form.certificate_number,
            country: this.form.country,
            city: this.form.city,
            address: this.form.address,
            postcode: this.form.postcode,
            description: this.form.description,
            first_name_zh: this.form.first_name_zh,
            last_name_zh: this.form.last_name_zh,
            first_name_en: this.form.first_name_en,
            last_name_en: this.form.last_name_en,
            institution_en: this.form.institution_en,
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  this.$message.success('更新成功');
                  this.$store.dispatch('toGetCurrentUser');
                } else {
                  this.$message.error(res.data.message);
                }
              } else {
                this.$message.error('未请求成功');
                console.log('错误');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
  computed: {
    form: {
      get() {
        return this.$store.state.toGetCurrentUser.currentUserInfo;
      },
    },
  },
};
</script>

<style scoped></style>
